import { pdfjs } from "react-pdf";

import "core-js/proposals/promise-with-resolvers";

// Self-hosted pdf.js worker, served from /public. It MUST match the pdfjs-dist version
// react-pdf bundles (currently 5.4.296 via react-pdf 10.4.1) or react-pdf throws an
// API/Worker version mismatch. When bumping react-pdf, re-copy the worker:
//   cp node_modules/.bun/pdfjs-dist@<version>/node_modules/pdfjs-dist/build/pdf.worker.min.mjs public/pdf.worker.min.mjs
// We self-host (rather than a CDN) because cdnjs doesn't carry every pdfjs patch release.
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";
